<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список ПО/ОС</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование</li>
        </ol>
    </nav>

    <div class="form-body">
        <div class="form-narrow mb-4">
            <div class="mb-4">
                <label class="form-label">Название ПО <span class="color-red">*</span></label>
                <input type="text" class="form-control" v-model="name">
            </div>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Изменить'" @btnClick="update"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';
import DeviceSoftware from '../../../../models/DeviceSoftware';
import Alert from '../../../alerts/Alert.vue';
import axios from 'axios'
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'DeviceSoftwareEditComponent',
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_get: String,
        route_update: String,
        device_software_id: {
            type: [Number, String],
        }
    },
    data: function () {
        return {
            deviceSoftware: new DeviceSoftware({
                route_get: this.route_get
            }),
            name: '',
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        itemGet: async function () {
            let item = await this.deviceSoftware.get(this.device_software_id);
            this.name = item.name;
        },
        update: async function () {            
            if (this.name === '') {
                this.addAlert({ type: 'warning', title: 'Предупрежение', text: 'Введите название ПО/ОС' });
                return;
            }

            let response = await axios.post(
                this.route_update,
                {
                    id: this.device_software_id,
                    name: this.name,
                }
            );

            if(response.data.status == 'ok') {
                window.location.href = this.route_back;
            }
        },
    },
    mounted() {
        this.itemGet();
    }
}
</script>

<style scoped>

</style>
